const loading = document.querySelector('.loading')

window.onload = () => {
    loading.style.opacity = '0'
    
    setTimeout(() => {
        loading.style.display = 'none'
        if (document.querySelector('.hero')) {
            document.querySelector('.hero').classList.add('loaded')
        }
    }, 500);
}

import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'

const analytics = Analytics({
  app: 'Merci Poupou Microsite',
  plugins: [
    googleTagManager({
      containerId: 'GTM-PXK6VHF'
    })
  ]
})

const base = require('./base.js')
const animation = require('./animation.js')